<template>
  <component
    :is="tag"
    ref="tippyRef"
  >
    <slot></slot>
    <span ref="contentRef" class="d-none">
      <slot name="content"></slot>
    </span>
  </component>
</template>

<script>
import { ref, markRaw, onMounted, onUnmounted, watch } from 'vue'
import tippy from 'tippy.js'

export default {
  name: 'TippyTooltip',
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    content: {
      type: String
    },
    tippyOptions: {
      type: Object
    }
  },
  setup (props) {
    const tippyRef = ref(null)
    const contentRef = ref(null)
    const tippyInstance = ref(null)

    onMounted(() => {
      let content = props.content
      let allowHTML = false

      if (contentRef.value.innerHTML) {
        content = contentRef.value.innerHTML
        allowHTML = true
      }

      tippyInstance.value = markRaw(tippy(tippyRef.value, {
        ...props.tippyOptions,
        content,
        allowHTML
      }))
    })

    onUnmounted(() => {
      if (tippyInstance.value) {
        tippyInstance.value.destroy()
      }
    })

    watch(() => props.content, (content) => {
      if (tippyInstance.value) {
        tippyInstance.value.setContent(content)
      }
    })

    return {
      tippyRef,
      contentRef
    }
  }
}
</script>
